import { FC } from 'react';
import { Controller, useFormContext } from 'rhf-v7';
import CheckoutPaymentContainer from 'src/v2-components/shared/CheckoutPaymentContainer';
import { AirInitiateBookingResponse } from 'obt-common/types/api/v1/obt/air/air_intitate_booking_response';
import { IUserOrgId, ListBookingPaymentSourcesRequestType } from 'obt-common';
import { BookingWorkflowType } from 'obt-common/types/api/v2/obt/model/booking-workflow-type';
import { useParams } from 'react-router-dom';
import { RetryPaymentCheckoutFormValues } from '../FormProvider/types';
import useGetTravelerProfileResponse from '../hooks/useGetTravelerProfileResponse';
import { IRetryPaymentParams } from '../types';

/**
 * Renders a form-controlled wrapper around payment method
 */
const PaymentOptionsContainer: FC = () => {
  const { control } = useFormContext<RetryPaymentCheckoutFormValues>();

  const traveler = useGetTravelerProfileResponse();
  const { tripId, pnrId } = useParams<IRetryPaymentParams>();

  return (
    <Controller
      name="selectedPaymentSourceIds"
      control={control}
      render={({ field: { value, onChange } }) => (
        <CheckoutPaymentContainer
          itineraryId=""
          bookingType={ListBookingPaymentSourcesRequestType.AIR}
          onPaymentSourceSelect={(paymentSources) => {
            const paymentSourceIds = paymentSources.map((source) => source.id);
            onChange(paymentSourceIds);
          }}
          selectedPaymentSourceIds={value}
          primaryTravelerId={traveler?.userOrgId as IUserOrgId}
          initiateOrderResponse={{} as AirInitiateBookingResponse}
          pnrId={pnrId}
          bookingWorkflowType={BookingWorkflowType.RetryPayment}
          tripId={tripId}
        />
      )}
    />
  );
};

export default PaymentOptionsContainer;
